<template>
    <div class="text-center">
        <i class="fal fa-spinner fa-spin fa-2x"></i>
        <form method="post" :action="setupResponse.data.url" ref="form">
            <input v-for="(value, name) in setupResponse.data.fields" type="hidden" :name="name" :value="value" />
        </form>
    </div>
</template>

<script>

    import {mapState} from "vuex";

    export default {
        name: "SetupResponseRedirect",
        computed: {
            ...mapState({
                setupResponse: state => state.payment.setupResponse,
            })
        },
        mounted () {
            this.$refs['form'].submit();
        }
    }

</script>
